module.exports = __webpack_public_path__ + "img/newInt-backBtn-arrow.e1ea2e43.svg";